// extracted by mini-css-extract-plugin
export default {"option":"RenderText_option__xt6U-","correct":"RenderText_correct__g3Fao"};